import {setTitle} from '@github-ui/document-metadata'
import {CurrentUserProvider} from '@github-ui/agent-sessions/contexts/CurrentUserContext'
import {ConsecutiveCAPI401sProvider} from '@github-ui/copilot-shared-ui/capi/ConsecutiveCAPI401sContext'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useCurrentQueryRoute} from '@github-ui/react-core/future/use-current-query-route'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
/* eslint-disable-next-line @github-ui/github-monorepo/no-use-app-payload --
   useAppPayload is deprecated. See
   https://thehub.github.com/epd/engineering/dev-practicals/frontend/react/data-router/migration/app-payload-deprecation/ */
import {AppPayloadContext} from '@github-ui/react-core/use-app-payload'
import {useEffect} from 'react'

import type {CopilotAgentsSpacesPayload} from '../../types/copilot-agents-spaces-payload'
import {AgentsSidebarLayout} from '../AgentsSidebarLayout'
import {AgentsSpacesPageContent} from './AgentsSpacesPageContent'
import {AgentsSpacesListView} from './AgentsSpacesListView'

export function CopilotAgentsSpacesListPage() {
  const currentRoute = useCurrentQueryRoute()
  const {data: payload} = useRouteQuery(currentRoute, 'mainQuery')

  if (!payload) {
    return null
  }

  return <CopilotAgentsSpacesListPageContent payload={payload as CopilotAgentsSpacesPayload} />
}

export function CopilotAgentsSpacesListPageContent({payload}: {payload: CopilotAgentsSpacesPayload}) {
  useEffect(() => {
    setTitle('Spaces · Agents · GitHub Copilot')
  }, [])

  return (
    <AppPayloadContext value={payload}>
      <CurrentUserProvider currentUser={payload.currentUser} currentUserIsSessionOwner>
        <ConsecutiveCAPI401sProvider>
          <ErrorBoundary boundaryName="CopilotAgentsSpacesListPageContent">
            <AgentsSidebarLayout
              agentsEnabled={!!payload.agentsEnabled}
              showSpacesNav={payload.spacesEnabled}
              showCustomizeNav={payload.customizeEnabled}
              currentUserLogin={payload.currentUser?.login}
              currentUserId={payload.currentUser?.id}
              enterpriseSandboxEnabled={payload.enterpriseSandboxEnabled !== false}
              taskGroups={payload.taskGroups}
              contentKey="spaces"
              sidebarProps={{isSpacesActive: true}}
            >
              <AgentsSpacesPageContent>
                {payload.spacesEnabled ? (
                  <AgentsSpacesListView
                    currentUserLogin={payload.currentUser?.login ?? ''}
                    isIndividualAccessEnabled={payload.customCopilotsIndividualAccessEnabled}
                  />
                ) : (
                  <p>Spaces are not enabled for your account.</p>
                )}
              </AgentsSpacesPageContent>
            </AgentsSidebarLayout>
          </ErrorBoundary>
        </ConsecutiveCAPI401sProvider>
      </CurrentUserProvider>
    </AppPayloadContext>
  )
}
